<template>
  <div class="row">

    <div class="col-xs-12">
      <h5 class="col-xs-8">FCA Firm Reference Number</h5>
      <div class="col-xs-4">
        <h4><i v-if="fca_sync_queued" class="fa fa-spinner fa-spin" style="padding: 10px 10px;"></i>{{ firmReferenceNumber }}</h4>
        <template v-if="!accountId">
          <a href="/additional">
            <i class="fa fa-edit"></i>
          </a>
          <span> Please click to edit FCA Firm Reference Number and update/change any general questions</span>
          <hr>
          <a type="button" @click="updateFcaData">
            <i class="fa fa-refresh" id="updating_button"></i>
          </a>
          <span> Please click to reload FCA Firm data</span>
        </template>
      </div>
    </div>
    <template v-if="!updatedMessage">
    <div class="col-xs-12"><hr></div>
    <div class="col-xs-12">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Firm name</span></h5>
      <table v-if="firmNamesReceived" class="table table-striped">
        <thead>
        <tr>
          <th>
            Name
          </th>
          <th>
            Effective from
          </th>
          <th>
            Status
          </th>
        </tr>
        </thead>
        <tbody>

        <tr v-for="firmName in firmNames">
          <th>
            <p>{{ firmName.name }}</p>
          </th>
          <td>
            <p>{{ firmName.effective_from}}</p>
          </td>
          <td>
            <p>{{ firmName.status }}</p>
          </td>
        </tr>

        </tbody>
      </table>
      <p v-if="!firmNamesReceived">Not yet uploaded</p>
    </div>
    <div class="col-xs-12"><hr></div>
    <div class="col-xs-12">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Firm details</span></h5>
      <table v-if="firmDetailsReceived" class="table table-striped">
        <tbody>
        <tr v-for="(value, key) in firmDetails">
          <template v-if="inArray(value.title, ['Permission','Passport','Regulators','Appointed Representative','Address','DisciplinaryHistory','E-Money Agent Status','PSD / EMD Effective Date','Client Money Permission','Companies House Number','Status','Business Type'])">
            <th>
              <p>{{ key + 1 }}</p>
            </th>
            <td>
              <p>{{ value.title }}</p>
            </td>
            <td>
              <p>{{ value.value }}</p>
            </td>
          </template>
        </tr>
        </tbody>
      </table>
      <p v-if="!firmDetailsReceived">Not yet uploaded</p>
    </div>
    <div class="col-xs-12"><hr></div>
    <div class="col-xs-12">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Firm Address</span></h5>
      <template v-if="firmAddressesReceived" v-for="firmAddress in firmAddresses">
        <table class="table table-striped">
          <tbody>
          <tr>
            <th>
              <p>Website address</p>
            </th>
            <td>
              <p>{{ firmAddress.website_address }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Phone number</p>
            </th>
            <td>
              <p>{{ firmAddress.phone_number }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Postcode</p>
            </th>
            <td>
              <p>{{ firmAddress.postcode }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>County</p>
            </th>
            <td>
              <p>{{ firmAddress.county }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Town</p>
            </th>
            <td>
              <p>{{ firmAddress.town }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Address line 1</p>
            </th>
            <td>
              <p>{{ firmAddress.address_line_1 }}</p>
            </td>
          </tr>
          </tbody>
        </table>
      </template>
      <p v-if="!firmAddressesReceived">Not yet uploaded</p>
    </div>
    <div class="col-xs-12"><hr></div>
    <div class="col-xs-12">
      <h5 class="col-xs-8">
        FCA firm Information
        <span class="small">Firm individuals</span>
      </h5>

      <div class="col-xs-8">
        <a v-if="firmIndividualsReceived" :href="accountId ? `/member-firm/fca/${accountId}/individual-permission` : 'fca/individual-permission'">
          <i class="fa fa-edit"></i>
        </a>
        <span>Please click to see individual permissions list dashboard</span>
      </div>

      <table v-if="firmIndividualsReceived" class="table table-striped">
        <thead>
        <tr>
          <th>
            #
          </th>
          <th>
            Full name
          </th>
        </tr>
        </thead>
        <tbody>

        <tr v-for="(firmIndividual, index) in firmIndividuals">
          <th>
            <p>{{ index + 1}}</p>
          </th>
          <th>
            <p>{{ firmIndividual.name }}</p>
          </th>
        </tr>

        </tbody>
      </table>
      <p v-if="!firmIndividualsReceived">Not yet uploaded</p>
    </div>
    <div class="col-xs-12"><hr></div>
    <div class="col-xs-12">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Firm permissions</span></h5>
      <table v-if="firmPermissionsReceived" class="table table-striped">
        <thead>
        <tr>
          <th>
            #
          </th>
          <th>
            Name
          </th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(value, key) in firmPermissions">
          <th>
            <p>{{ key + 1 }}</p>
          </th>
          <td>
            <p>{{ value.name }}</p>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="!firmPermissionsReceived">Not yet uploaded</p>
    </div>

      <div class="col-xs-12"><hr></div>
      <div class="col-xs-12">
        <h5 class="col-xs-8">FCA firm Information <span class="small">Requirements</span></h5>
        <div class="col-xs-8">
          <a :href="accountId ? `/member-firm/fca/${accountId}/show/firm_requirements` : 'fca/show/firm_requirements'">
            <i class="fa fa-edit"></i>
          </a>
          <span>Please click to see requirements list dashboard</span>
        </div>
      </div>

      <div class="col-xs-12"><hr></div>
      <div class="col-xs-12">
        <h5 class="col-xs-8">FCA firm Information <span class="small">Regulators</span></h5>
        <div class="col-xs-8">
          <a :href="accountId ? `/member-firm/fca/${accountId}/show/firm_regulators` : 'fca/show/firm_regulators'">
            <i class="fa fa-edit"></i>
          </a>
          <span>Please click to see regulators list dashboard</span>
        </div>
      </div>

      <div class="col-xs-12"><hr></div>
      <div class="col-xs-12">
        <h5 class="col-xs-8">FCA firm Information <span class="small">Passports</span></h5>
        <div class="col-xs-8">
          <a :href="accountId ? `/member-firm/fca/${accountId}/show/firm_passports` : 'fca/show/firm_passports'">
            <i class="fa fa-edit"></i>
          </a>
          <span>Please click to see passports list dashboard</span>
        </div>
      </div>


      <div class="col-xs-12"><hr></div>
      <div class="col-xs-12">
        <h5 class="col-xs-8">FCA firm Information <span class="small">Waivers</span></h5>
        <div class="col-xs-8">
          <a :href="accountId ? `/member-firm/fca/${accountId}/show/firm_waivers` : 'fca/show/firm_waivers'">
            <i class="fa fa-edit"></i>
          </a>
          <span>Please click to see waivers list dashboard</span>
        </div>
      </div>


      <div class="col-xs-12"><hr></div>
      <div class="col-xs-12">
        <h5 class="col-xs-8">FCA firm Information <span class="small">Exclusions</span></h5>
        <div class="col-xs-8">
          <a :href="accountId ? `/member-firm/fca/${accountId}/show/firm_exclusions` : 'fca/show/firm_exclusions'">
            <i class="fa fa-edit"></i>
          </a>
          <span>Please click to see exclusions list dashboard</span>
        </div>
      </div>

    <div class="col-xs-12"><hr></div>
    <div class="col-xs-12">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Disciplinary Histories</span></h5>
      <div class="col-xs-8">
        <a :href="accountId ? `/member-firm/fca/${accountId}/show/firm_disciplinary_histories` : 'fca/show/firm_disciplinary_histories'">
          <i class="fa fa-edit"></i>
        </a>
        <span>Please click to see disciplinary histories list dashboard</span>
      </div>
      </div>

    <div class="col-xs-12"><hr></div>
    <div class="col-xs-12">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Appointed Representatives</span></h5>
      <div class="col-xs-8">
        <a :href="accountId ? `/member-firm/fca/${accountId}/show/firm_appointed_representatives` : 'fca/show/firm_appointed_representatives'">
          <i class="fa fa-edit"></i>
        </a>
        <span>Please click to see appointed representatives list dashboard</span>
      </div>
    </div>

      <div class="col-xs-12"><hr></div>
      <div class="col-xs-12">
        <h5 class="col-xs-8">FCA firm Information <span class="small">Products</span></h5>
        <div class="col-xs-8">
          <a :href="accountId ? `/member-firm/fca/${accountId}/show/firm_products` : 'fca/show/firm_products'">
            <i class="fa fa-edit"></i>
          </a>
          <span>Please click to see products list dashboard</span>
        </div>
      </div>

    </template>
    <template v-else>
      <div class="col-xs-12">
        <h5 class="col-xs-8">{{updatedMessage}}</h5>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "FCAFirmInfoComponent",
  props: {
    accountId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      firmReferenceNumber: null,
      firmReferenceNumberReceived: false,
      firmNames: [
        {
          'name': null,
          'status': null,
          'effective_from': null,
          'effective_to': null,
          'is_current': null,
        }
      ],
      firmNamesReceived: false,
      firmDetails: [],
      firmDetailsReceived: false,
      firmAddresses: [],
      firmAddressesReceived: false,
      firmIndividuals: [
        {
          'name': null,
        }
      ],
      firmIndividualsReceived: false,
      firmPermissions: [],
      firmPermissionsReceived: false,

      updatedMessage: null,

      fca_sync_queued: false,
    }
  },
  created() {
    this.getFcaData();
  },
  methods: {
    getFcaData() {
      const path = this.accountId ? `/member-firm/fca/${this.accountId}/get-data` : '/fca/get-data';
      axios.get(path).then((res) => {
        this.firmReferenceNumber = res.data.firm_reference_number;
        this.firmReferenceNumberReceived = !!this.firmReferenceNumber;

        this.firmNames = res.data.firm_names;
        this.firmNamesReceived = this.firmNames.length > 0;

        this.firmDetails = res.data.firm_details;
        this.firmDetailsReceived = this.firmDetails.length > 0;

        this.firmAddresses = res.data.firm_addresses;
        this.firmAddressesReceived = this.firmAddresses.length > 0;

        this.firmIndividuals = res.data.firm_individuals;
        this.firmIndividualsReceived = this.firmIndividuals.length > 0;

        this.firmPermissions = res.data.firm_permissions;
        this.firmPermissionsReceived = this.firmPermissions.length > 0;

        if(res.data.fca_sync_queued) {
          this.fca_sync_queued = res.data.fca_sync_queued;
          this.startAutoRefresh();
        } else {
          this.fca_sync_queued = res.data.fca_sync_queued;
        }

      }).catch((error) => {
        console.log('error', error)
      })
    },
    inArray(needle, haystack) {
      return haystack.includes(needle);
    },
    updateFcaData() {
      this.inProcess(true)
      axios.get('/fca/update-data-fca').then((res) => {
        this.updatedMessage = res.data.message;
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }).catch((error) => {
        this.updatedMessage = error.message;
        console.log('error', error)
      })
    },
    inProcess(process) {
      const icon = document.getElementById('updating_button');
      if (process) {
        icon.classList.add("fa-spin");
      } else {
        icon.classList.remove("fa-spin");
      }
    },
    startAutoRefresh() {
      setTimeout(() => {
        this.getFcaData();
      }, 2000);
    },
  },
}
</script>

<style scoped>

</style>